import React, { useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { RiEdit2Fill } from "react-icons/ri";
import { Form, Dropdown } from "react-bootstrap";
import { FaPlus, FaXmark } from "react-icons/fa6";
import { GoSidebarCollapse } from "react-icons/go";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import {
  BsDownload,
  BsFilter,
  BsInbox,
  BsSearch,
  BsSendFill,
  BsUpload,
} from "react-icons/bs";

const ToolBar = ({
  sendNow,
  toggles,
  search,
  setSearch,
  checkedIds,
  setCheckedIds,
  showPreview,
  setShowPreview,
  setSelected,
  start,
  end,
  totalItems,
  deleteData,
  page,
  setPage,
  totalPages,
  addField,
  selectField,
  editField,
  setPageSize,
  pageSize,
  exportData,
  importData,
}) => {
  const [filterDropdown, setFilterDropdown] = useState(false);
  return (
    <>
      <div className="p-2 border-bottom bg-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div className="d-flex align-items-center gap-2">
            {addField && (
              <button
                className="icon-btn primary"
                title="Add New"
                onClick={() => toggles.setToggle()}
              >
                {sendNow ? <BsSendFill size={12} /> : <FaPlus size={12} />}
              </button>
            )}
            {selectField && (
              <div className="select-with-icon">
                <span className="select-icon">
                  <BsInbox />
                </span>
                <Form.Select size="sm" className="bg-light">
                  <option>All</option>
                  <option>Chats</option>
                  <option>Tickets</option>
                  <option>Trash</option>
                  <option>Spam</option>
                </Form.Select>
              </div>
            )}
            <div className="position-relative">
              <BsSearch className="search-icon" />
              <Form.Control
                size="sm"
                placeholder="Search..."
                className="search-input"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1);
                }}
              />
            </div>
            <Dropdown
              className="position-relative"
              align="end"
              show={filterDropdown}
              onToggle={(show) => setFilterDropdown(show)}
            >
              <Dropdown.Toggle
                as="button"
                className="icon-btn"
                title="Filter"
                id="toolbar-filter-dropdown"
              >
                <BsFilter />
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="shadow-sm"
                style={{
                  minWidth: "200px",
                  animation: filterDropdown
                    ? "dropdownSlideIn 0.3s ease"
                    : "none",
                }}
              >
                <Dropdown.Item className="menu-item">
                  <span className="fw-500">Date Range</span>
                </Dropdown.Item>
                <Dropdown.Item className="menu-item">Status</Dropdown.Item>
                <Dropdown.Item className="menu-item">Priority</Dropdown.Item>
                <Dropdown.Item className="menu-item">Agent</Dropdown.Item>
                <Dropdown.Item className="menu-item">Tags</Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  className="menu-item text-danger"
                  onClick={() => setFilterDropdown(false)}
                >
                  Clear Filters
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="d-flex align-items-center gap-3 text-muted small">
            {checkedIds?.length > 0 && (
              <>
                <span className="fw-medium">{checkedIds.length} selected</span>
                {checkedIds?.length === 1 && editField && (
                  <>
                    <div className="vr" />
                    <button
                      title="Edit"
                      className="icon-btn"
                      onClick={() => toggles.setToggle1()}
                    >
                      <RiEdit2Fill />
                    </button>
                  </>
                )}
                <div className="vr" />
                <button
                  className="icon-btn danger"
                  title="Delete"
                  onClick={deleteData}
                  disabled={!checkedIds?.length}
                >
                  <FaTrashAlt />
                </button>
              </>
            )}
            {(checkedIds?.length > 0 || search) && (
              <>
                <button
                  className="icon-btn danger"
                  title="Clear"
                  onClick={() => {
                    setSearch("");
                    setCheckedIds([]);
                    setPage(1);
                  }}
                >
                  <FaXmark />
                </button>
                <div className="vr" />
              </>
            )}

            {showPreview && (
              <>
                <button
                  className="icon-btn"
                  title="Collpase Preview"
                  onClick={() => {
                    setShowPreview("");
                    setSelected("");
                  }}
                >
                  <GoSidebarCollapse />
                </button>
                <div className="vr" />
              </>
            )}
            {exportData && (
              <>
                <button className="icon-btn" title="Import">
                  <BsDownload />
                </button>
                <div className="vr" />
              </>
            )}
            {importData && (
              <>
                <button className="icon-btn" title="Upload">
                  <BsUpload />
                </button>
                <div className="vr" />
              </>
            )}
            <span>
              {start}–{end} of {totalItems}
            </span>
            <Form.Select
              size="sm"
              style={{ width: 70 }}
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              {[5, 10, 15, 25, 50, 100, 500].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </Form.Select>
            <div className="d-flex gap-1">
              <button
                className="icon-btn"
                title="Previous"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                <IoIosArrowBack />
              </button>

              <button
                className="icon-btn"
                title="Next"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                <IoIosArrowForward />
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ToolBar;
